export interface Vendor {
    id: string;
    email: string;
    title: string;
    phone: string | null;
    logo: string | null;
    externalUuid: string;
    isOperationsActivated: boolean;
    isRenovationsActivated: boolean;
    sellerType: string;
    speciality: string[];
    states: string[];
    description: string;
    headquarters: string;
    website: string;
    isAddToProperty?: boolean;
    brandColor: string;
    operationsAccountNumber: string;
    primaryContact: string;
    primaryContactPhone: string;
    primaryContactEmail: string;
    vendorEmail?: string;
    vendorPhone?: string;
    operationsAccountStatus: VendorActivationStatus;
    renovationsAccountStatus: VendorActivationStatus;
}

export enum VendorActivationStatus {
    INITIAL = 'INITIAL',
    INVALID = 'INVALID',
    VERIFYING = 'VERIFYING',
    VERIFIED = 'VERIFIED',
}

export interface VendorsResponseSchema {
    data: Vendor[];
}

export interface SpecialtiesResponseSchema {
    data: string[];
}

export interface VendorsSchema {
    vendorsList: Vendor[];
    vendorsMap: Record<string, Vendor> | null;
    allVendorsList: Vendor[];
    allSpecialties: string[];
    dataIsLoading: boolean;
    currentVendorToAdd: Vendor | null;
    isShowVendorToAddDialog: boolean;
}

export interface VendorInfoSchema {
    name?: string;
    email?: string;
    phone?: string;
    primaryContact?: boolean;
}

export interface VendorInfoResponse {
    accountManager: {
        operationsAccount: {
            number: string;
        };
        renovationsAccount: {
            number: string;
        };
        name: string;
        email: string;
        phone: string;
        primaryContact: true;
        vendorId: string;
        operationsActivationStatus: string;
        renovationsActivationStatus: string;
    };
}
